/** Evita ler e.target dentro do updater (React 16 nullifica eventos sintéticos). */
export default function handleFieldChange(setter, field) {
  return event => {
    const { value } = event.target;
    setter(prev => ({ ...prev, [field]: value }));
  };
}
